import PropTypes from 'prop-types';
/* global google */
import React from 'react';
import { Search } from 'semantic-ui-react';
import { CardInput as Input } from '../../Elements';
import './LocationAutocomplete.scss';

export default class LocationAutocomplete extends React.Component {

  static propTypes = {
    updateLocalEventSegment: PropTypes.func,
    eventSegment: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      locationIsLoading: false,
      locationSuggestions: [],
      userLocation: null
    };
    if (google) {
      // We must send a DOM element proving we are providing attribution for usage
      this.state.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    }
    this.locationOnFocus = this.locationOnFocus.bind(this);
    this.locationOnBlur = this.locationOnBlur.bind(this);
    this.onLocationSelect = this.onLocationSelect.bind(this);
    this.onLocationSearchChange = this.onLocationSearchChange.bind(this);
    this.updateLocationOptions = this.updateLocationOptions.bind(this);
  }

  onLocationSelect(e, data) {
    if (google) {
      const service = this.state.placesService;
      const addressParts = {};
      service.getDetails({ placeId: data.result.key }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          place.address_components.map((component) => {
            if (component.types.includes('street_number')) {
              addressParts.street_number = component.long_name;
            } else if (component.types.includes('route')) {
              addressParts.route = component.long_name;
            } else if (component.types.includes('locality')) {
              addressParts.city = component.long_name;
            } else if (component.types.includes('administrative_area_level_1')) {
              addressParts.province = component.long_name;
            } else if (component.types.includes('postal_code')) {
              addressParts.postal_code = component.long_name;
            }
            return component;
          });
        } else {
          // eslint-disable-next-line no-undef
          Bugsnag.notify(new Error(status), {
            metaData: {
              PlacesService: service
            },
            severity: 'error'
          });
        }
        this.props.updateLocalEventSegment(
          Object.assign(
            this.props.eventSegment, {
              location: place.name,
              line1: `${addressParts.street_number ? `${addressParts.street_number} ` : ''}${addressParts.route ? addressParts.route : ''}`,
              city: addressParts.city,
              province: addressParts.province,
              postal_code: addressParts.postal_code,
              room: ''
            }
          )
        );
      });
    }
  }

  onLocationSearchChange(e, data) {
    this.props.updateLocalEventSegment(
      Object.assign(
        this.props.eventSegment, {
          location: data.value
        }
      )
    );
    this.getLocationSuggestions(data.value);
  }

  getLocationSuggestions(input) {
    if (google && input !== '') {
      const location = this.state.userLocation;
      const service = new google.maps.places.AutocompleteService();
      const params = {
        input,
        types: ['establishment', 'geocode']
      };
      if (location) { Object.assign(params, { location, radius: 200000 }); }
      service.getPlacePredictions(params, this.updateLocationOptions);
      this.setState({ locationIsLoading: true });
    }
  }

  getUserLocation() {
    if (navigator.geolocation && google) {
      navigator.geolocation.getCurrentPosition(position => {
        this.setState({
          userLocation: new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          )
        });
      });
    }
    return null;
  }

  locationOnFocus(e) {
    this.getUserLocation();
    this.getLocationSuggestions(e.target.value);
  }

  locationOnBlur() {
    if (!this.props.eventSegment.location) {
      this.props.updateLocalEventSegment(
        Object.assign(
          this.props.eventSegment, {
            line1: null,
            city: null,
            province: null,
            postal_code: null,
            room: null,
            notes: null
          }
        )
      );
    }
  }

  updateLocationOptions(predictions, status) {
    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      return;
    }
    const locationSuggestions = predictions.map(prediction => ({
      title: prediction.structured_formatting.main_text,
      description: prediction.structured_formatting.secondary_text,
      key: prediction.place_id
    }));
    this.setState({ locationSuggestions, locationIsLoading: false });
  }

  render() {
    return (
      <Input
        label='Venue'
        name='location'
        submitted={this.state.submitted}
      >
        <Search
          loading={this.state.locationIsLoading}
          onResultSelect={this.onLocationSelect}
          onSearchChange={this.onLocationSearchChange}
          results={this.state.locationSuggestions}
          onFocus={this.locationOnFocus}
          onBlur={this.locationOnBlur}
          value={this.props.eventSegment.location || ''}
          fluid
          className='transparent locationAutocomplete'
          placeholder='Hyatt Regency'
          noResultsMessage='No venue suggestions'
        />
      </Input>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/EventSegment/LocationAutocomplete.js